import type { Components, Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

/**
 * No style override: every tooltip is MUI's own small dark label, the same hint everywhere in the app. The light card
 * this used to be read as a popover next to a copy icon. Shown above its target unless a tooltip asks otherwise.
 */
const MuiTooltip: Components<Theme>['MuiTooltip'] = {
  defaultProps: {
    placement: 'top',
  },
};

// ----------------------------------------------------------------------

export const tooltip = { MuiTooltip };
